<button routerLink="/pages/new">Seite hinzufügen</button>
<table *ngIf="pages$ | async as pages">
  <tr *ngFor="let page of pages">
    <td routerLink="/pages/{{ page.id }}">{{ page.title }}</td>
  </tr>
</table>
